import { UnfoldLess, UnfoldMore } from '@mui/icons-material';
import {
  Box,
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { ColumnDef } from './Column';
import { RowSelectionState } from './useRowSelection';

export interface HeaderProps<R, R2, C> {
  columns: readonly ColumnDef<R, C>[];
  detailColumns?: readonly ColumnDef<R2, C>[];
  context: C;
  rowSelection?: RowSelectionState;
  filteredSelectedKeys?: string[];
  disabledRowSelectionKeys?: string[];
  variant?: Variant;
}

export function Header<R, R2, C>({
  columns,
  context,
  variant = 'h5',
  rowSelection,
  filteredSelectedKeys,
  disabledRowSelectionKeys,
}: HeaderProps<R, R2, C>) {
  return (
    <TableRow>
      {/* Selected checkbox column */}
      {rowSelection && (
        <TableCell padding="checkbox">
          <Checkbox
            disabled={rowSelection.allKeys.size === 0}
            checked={
              rowSelection.allKeys.size > 0 &&
              rowSelection.allKeys.size === rowSelection.selectedKeys.size
            }
            indeterminate={
              rowSelection.allKeys.size > 0 &&
              rowSelection.allKeys.size > rowSelection.selectedKeys.size &&
              rowSelection.selectedKeys.size > 0
            }
            onChange={(_, checked) => {
              const keysToSelect =
                filteredSelectedKeys ?? Array.from(rowSelection.allKeys);

              const filteredKeys = disabledRowSelectionKeys
                ? keysToSelect.filter(
                    (key) => !disabledRowSelectionKeys.includes(key),
                  )
                : keysToSelect;

              rowSelection.setKeys(checked, filteredKeys);
            }}
          />
        </TableCell>
      )}

      {/* ColumnDef columns */}
      {columns.map((_, i) => {
        const primaryColumn = columns[i];
        return (
          <TableCell key={i}>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
              <Typography variant={variant} noWrap>
                {primaryColumn?.header(context)}
              </Typography>
              {primaryColumn?.sort && (
                <IconButton
                  onClick={() => primaryColumn?.sort?.sortFn?.(context)}
                >
                  {primaryColumn?.sort?.sortState === -1 ? (
                    <UnfoldLess />
                  ) : (
                    <UnfoldMore />
                  )}
                </IconButton>
              )}
            </Box>
          </TableCell>
        );
      })}
    </TableRow>
  );
}
